export default __webpack_public_path__ + "static/media/profile.e58b0c61.jpg";